import BaseViewController from "./base-view-controller";

class PharmacyResultTypesViewController extends BaseViewController {
  handleButtonClick(name, text, action, ...[, , eventStates]) {
    const {
      data: { selectedData }
    } = action || {};

    if (eventStates) {
      this.updateStates(eventStates, true, [...this.screen.fields]);
    }

    if (name === "submit") {
      if (selectedData === "mail_order") {
        super.handleButtonClick(
          name,
          {},
          {
            type: "url",
            value: "/screens/request_consult/gm/mail_order_pharmacy_list"
          }
        );
      } else if (selectedData === "sameday_delivery") {
        super.handleButtonClick(
          name,
          {},
          {
            type: "screen",
            value: "CapsulePrescriptionDelivery"
          }
        );
      } else {
        // TODO: this would not work with current location
        this.appData.searchRetailPharmacies();
      }
    }
  }
}

export default PharmacyResultTypesViewController;
